/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ score: NonNullable<unknown> }} Matches_ScoreInputs */

const cs_matches_score = /** @type {(inputs: Matches_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Skóre ${i?.score}`)
};

const en_matches_score = /** @type {(inputs: Matches_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Score ${i?.score}`)
};

/**
* | output |
* | --- |
* | "Score {score}" |
*
* @param {Matches_ScoreInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const matches_score = /** @type {((inputs: Matches_ScoreInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matches_ScoreInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_matches_score(inputs)
	return cs_matches_score(inputs)
});